export enum RenewalType {
  SUBSCRIPTION_AUTO = 'SUBSCRIPTION_AUTO',
  SUBSCRIPTION_MANUAL = 'SUBSCRIPTION_MANUAL',
}
